var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicationDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.079,
    height: 39.079,
    viewBox: "0 0 39.079 39.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medication-disable",
    transform: "translate(-774.461 -279.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medication",
    transform: "translate(408.379 -1.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "medication-2",
    "data-name": "medication",
    transform: "translate(369.526 286.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2193",
    "data-name": "Group 2193",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M189.486,1.905a7.151,7.151,0,0,0-9.721,0L170.55,10.6l9.727,9.2,9.208-8.7A6.251,6.251,0,0,0,189.486,1.905Z",
    transform: "translate(-159.352 0)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M2.06,192.7a6.269,6.269,0,0,0,0,9.2,7.173,7.173,0,0,0,9.727,0l8.269-7.821-9.727-9.206Z",
    transform: "translate(-0.05 -173.391)",
    fill: "#9a9a9a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "syringe-svgrepo-com_1_",
    "data-name": "syringe-svgrepo-com(1)",
    transform: "translate(401.715 286.476) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2197",
    "data-name": "Group 2197",
    transform: "translate(0.042 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2196",
    "data-name": "Group 2196",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M292.409,2.116c-1.487-1.487-3-2.4-3.357-2.036-.29.29.241,1.345,1.271,2.517l-5.566,5.566L282.771,6.17l-1.1,1.1,5.658,5.633,1.1-1.1-2.086-2.061L291.91,4.2c1.172,1.006,2.227,1.561,2.517,1.271C294.81,5.09,293.9,3.6,292.409,2.116Z",
    transform: "translate(-264.29 0)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M315.724,51.4,314.5,50.2l-2.135,2.135,1.2,1.2Z",
    transform: "translate(-293.096 -47.099)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M385.467,125.431l1.222,1.2,2.135-2.135-1.222-1.2Z",
    transform: "translate(-361.685 -115.688)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M100.967,140.489l5.732,5.732,10.212-10.193L111.16,130.3Z",
    transform: "translate(-94.74 -122.256)",
    fill: "#9a9a9a",
    stroke: "#bfbfbf",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M93.167,330.16l3.332,3.307.864-.839L94.031,329.3Z",
    transform: "translate(-87.421 -308.978)",
    fill: "#9a9a9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M5.116,372.2l.333.333L.222,377.759a.607.607,0,0,0,0,.864h0a.607.607,0,0,0,.864,0L6.313,373.4l.333.333.7-.7L5.782,371.5Z",
    transform: "translate(-0.042 -348.574)",
    fill: "#9a9a9a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "syringe-svgrepo-com",
    transform: "translate(437 193.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2199",
    "data-name": "Group 2199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2198",
    "data-name": "Group 2198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M0,48.779a1.483,1.483,0,0,0,1.484,1.469,1.5,1.5,0,0,0,1.484-1.469c.062-1.258-1.484-3.347-1.484-3.347S0,47.4,0,48.779Z",
    transform: "translate(-67 49)",
    fill: "#9a9a9a"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M37,0,21.391,15.609,0,37",
    transform: "matrix(1, 0.017, -0.017, 1, 775.826, 280.68)",
    fill: "none",
    stroke: "#848484",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationDisable);
export default __webpack_public_path__ + "static/media/medication-disable.8614b2805dce09e949707f1bbb5641dc.svg";
export { ForwardRef as ReactComponent };